module.exports = __webpack_public_path__ + "img/vignettes-asso_0004_maison-des-jeunes-talents.51ea3add.jpg";